import { render, staticRenderFns } from "./VSeparator.vue?vue&type=template&id=d72eaa94"
import script from "./VSeparator.vue?vue&type=script&lang=js"
export * from "./VSeparator.vue?vue&type=script&lang=js"
import style0 from "./VSeparator.vue?vue&type=style&index=0&id=d72eaa94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports